import FirstBanner from "../../components/FirstBanner";
import DiningList from "../../components/ThingsToDo/DiningList";
import splash_img from "../../assets/splash.webp";
import useFetch from "../../customFunction/useFetch";
import { motion } from "framer-motion";
import {useLanguage} from '../../lang/LangProvider';

const containerVariants = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { delay: 0.35, duration: 0.5 }
  },
  exit: {
    y: -30,
    opacity: 0,
    transition: { duration: 0.35 }
  }
}
const Dining = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { translate, currentLanguage} = useLanguage();
  const { data, isPending, error } = useFetch(apiUrl + 'dinning?lang='+currentLanguage);
  localStorage.setItem("titlePage", translate('menus.dining'));

  return (
    <motion.div className="position-relative"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <FirstBanner color1="yellow">
        <div className="button-title mx-auto mb-2">{translate('menus.dining')}</div>
        <h2 className="secondary-title text-center text-white">{translate('dining.sub_heading')}</h2>
      </FirstBanner>
      <div className="section pt-1">
        <div className="container">
          {isPending && ' '}
          {error && error.message}
          {data && <DiningList noPointer={true} dinings={data} />}
        </div>
      </div>
      <img className="splash-bottom" alt="splash" src={splash_img} />
    </motion.div>
  );
};

export default Dining;
